import React, { useEffect } from 'react'
import MUIDataTable from "mui-datatables";
import EditIcon from '@material-ui/icons/Edit';
import { createMuiTheme, MuiThemeProvider, Switch, TableCell, TextField, Typography, withStyles, InputAdornment, Checkbox } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import DaftarReservasi from './daftarReservasi';
import AddDocter from '../MasterData/addDocter';
import DetailDocter from '../MasterData/detailDocter';
import FilterDocter from '../MasterData/filterDokter';
import { getDocter } from '../../store/actions/dokterAction';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { useDispatch, useSelector } from 'react-redux';
import api from '../api';
import filterIcon from '../../assets/ic_search@3x.png';
import CloseImage from '../../assets/ic_close.png';
import { format } from 'date-fns';
import search from '../../assets/search.png';
import ic_detail from '../../assets/ic_detail.png';
import { useHistory } from 'react-router-dom';
import { FormGroup } from '@material-ui/core';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptionsSearch()

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 20,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const CustomCheckbox = withStyles({
    root: {
        color: '#2a9c6c',
        '&$checked': {
            color: '#2a9c6c',
        },
        padding: 5,
        borderRadius: 20,
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


export default function HistoryReservasi(props) {
    if (props.width) {
        let a = 0
        let x = props.width - a
        if (x !== -700) {
            a = props.width + x
        }
        // console.log(a);
    }
    const dokter = useSelector((store) => store.dokterReducer.dokter);
    const history = useHistory()
    const wrapperRef = React.createRef()
    const [visibleCreate, setVisibleCreate] = React.useState(false);
    const [visibleFilter, setVisibleFilter] = React.useState(false);
    const [visibleDetail, setVisibleDetail] = React.useState(false);
    const [listPoli, setListPoli] = React.useState(false)
    const [open, setOpen] = React.useState(true);
    const [startFrom, setStartFrom] = React.useState(null)
    const [tillFrom, setTillFrom] = React.useState(null)
    const [name, setName] = React.useState("");
    const [listDokter, setListDokter] = React.useState([])
    const [listDokterFilter, setListDokterFilter] = React.useState(null)
    const [detail, setDetail] = React.useState([])
    const [dataTable, setDatatable] = React.useState([])
    const [loading, setLoading] = React.useState(false);
    const [dataPoli, setDataPoli] = React.useState([])
    const [valuePoli, setValuePoli] = React.useState([])
    const [paramFilter, setParamFilter] = React.useState("")
    const [schedule_time, set_schedule_time] = React.useState("")
    const [validFrom, setValidFrom] = React.useState(null)
    const [validTo, setValidTo] = React.useState(null)

    React.useEffect(() => {
        props.setShowNotif(true)
        if (props && props.reservasi !== "") {
            let reservasi = props.reservasi
            // console.log(props.reservasi);
            if (reservasi.length > 0) {
                let dataTable = []
                reservasi.map((item, index) => {
                    let table = []
                    item.data.map((i, idx) => {
                        if (i.props) {
                            table.push(i.props.children)
                        } else {
                            table.push(i)
                        }
                    })
                    dataTable.push(table)
                })
                setListDokter(dataTable)
                // console.log(dataTable);
            } else {
                getData()
                getDataPoli()    
            }
        } else {
            getData()
            getDataPoli()
        }
    }, [])

    const getFilterBefore = (val) => {
        api.create().filterReservasiDokter(val === "" || val.length === 0 ? "is_history=1" : val).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data == false) {
                        setListDokterFilter(response.data.data)
                    } else {
                        let temp = []
                        let listDokter = response.data.data.map((item, index) => {
                            let monthData = new Date(item.doctor_schedule_date).getMonth() + 1
                            let monthNow = new Date().getMonth() + 1
                            let dateData = new Date(item.doctor_schedule_date).getDate()
                            let dateNow = new Date().getDate()
                            if (monthData <= monthNow) {
                                let arr = [
                                    item.doctor_schedule_date,
                                    item.booking_id,
                                    item.payment_option_name,
                                    item.polyclinics_name,
                                    item.doctor_name,
                                    item.patient_name,
                                    item.patient_phone,
                                    item.queue_number,
                                    item.doctor_schedule_time,
                                    item.appointment_status_name,
                                    item.appointment_reasons,
                                    item.appointment_id,
                                    item.appointment_id,
                                    item.doctor_id,
                                    item.doctor_schedule_detail_id,
                                    item.doctor_schedule_id,
                                ]
                                temp.push(arr)
                            }
                        })
                        setListDokterFilter(temp)
                    }
                    forceUpdate()
                }
                setVisibleFilter(false)
            }
        })
    }

    const getDataPoli = () => {
        api.create().getListMasterPoli().then(response => {
            console.log(response);
            if (response.data) {
                setDataPoli(response.data.data)
            }
            setLoading(false)
        })
    }

    const updateDateRange = (a, b) => {
        // console.log(a, b);
        const c = listDokter.filter((item) => {
            return Number(format(new Date(item[0]), 'yyyyMMdd')) >= Number(a) && Number(format(new Date(item[0]), 'yyyyMMdd')) <= Number(b)
        });
        setListDokterFilter(c)
        forceUpdate()

    }

    const getData = () => {
        api.create().getReservasiDokterFilter("is_history=1").then(response => {
            console.log(response)
            let temp = []
            let count = 0;
            if (response.data) {
                let listDokter = response.data.data.map((item, index) => {
                    let monthData = new Date(item.doctor_schedule_date).getMonth() + 1
                    let monthNow = new Date().getMonth() + 1
                    let dateData = new Date(item.doctor_schedule_date).getDate()
                    let dateNow = new Date().getDate()
                    // console.log(dateData, dateNow)
                    // if (monthData <= monthNow && dateData < dateNow) {
                        let arr = [
                            item.doctor_schedule_date,
                            item.doctor_schedule_date,
                            item.booking_id,
                            item.payment_option_name,
                            item.polyclinics_name,
                            item.doctor_name,
                            item.patient_name,
                            item.patient_phone,
                            item.queue_number,
                            item.doctor_schedule_time,
                            item.appointment_status_name,
                            item.appointment_reasons,
                            item.appointment_id,
                            item.appointment_id,
                            item.doctor_id,
                            item.doctor_schedule_detail_id,
                            item.doctor_schedule_id,
                        ]
                        temp.push(arr)
                    // }
                })
                setListDokter(temp)
                // setLoading(false)
                // forceUpdate()
            } else {
                // setLoading(false)
            }
        })
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const options = {
        filterType: 'multiselect',
        fixedHeader: true,
        filter: true,
        search: true,
        sort: true,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: 10,
        responsive: 'scrollMaxHeight',
        onFilterChange: (columnChanged, filterList, c, d, e, f, g) => {
            console.log(columnChanged, filterList, c, d, e, f, g);
            props.setDataReservasi(e === undefined ? [] : e)
            if (columnChanged === null) {
                setListDokterFilter(null)
                setValidFrom(null)
                setValidTo(null)
                getData()
            }
        }
    };

    const columns = [
        {
            name: "doctor_schedule_date",
            label: "Tanggal",
            options: {
                filter: true,
                filterType: 'custom',
                onTableChange: console.log,
                resetFilter: () => {
                    console.log('masuk');
                },
                onFilterChange: (columnChanged, filterList) => {
                    console.log(`onFilterChange columnChanged: ${columnChanged}`);
                    console.log(filterList);
                },
                filterOptions: {
                    names: [],
                    logic(age, filters) {
                        if (filters[0] && filters[1]) {
                            return age < filters[0] || age > filters[1];
                        } else if (filters[0]) {
                            return age < filters[0];
                        } else if (filters[1]) {
                            return age > filters[1];
                        }
                        return false;
                    },
                    display: (a, b, c, d, e, f) => (
                        <div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    margin="normal"
                                    label="Tgl. Reservasi Awal"
                                    format="dd/MM/yyyy"
                                    clearable
                                    value={validFrom}
                                    maxDate={new Date().setDate(new Date().getDate() - 1)}
                                    onChange={(date) => {
                                        console.log(a, b, c, d, e, f);
                                        setValidFrom(date)
                                        if (validTo === null) {
                                            setValidTo(date)
                                        }
                                        date === null ? updateDateRange(format(new Date(), 'yyyyMMdd'), validTo === null ? format(new Date(date), 'yyyyMMdd') : format(new Date(validTo), 'yyyyMMdd')) : updateDateRange(format(new Date(date), 'yyyyMMdd'), validTo === null ? format(new Date(date), 'yyyyMMdd') : format(new Date(validTo), 'yyyyMMdd'))
                                        // forceUpdate()
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    ),
                },
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 77, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "doctor_schedule_date",
            options: {
                display: false,
                filterType: 'custom',
                filterOptions: {
                    names: [],
                    logic(age, filters) {
                        if (filters[0] && filters[1]) {
                            return age < filters[0] || age > filters[1];
                        } else if (filters[0]) {
                            return age < filters[0];
                        } else if (filters[1]) {
                            return age > filters[1];
                        }
                        return false;
                    },
                    display: (filterList, onChange, index, column) => (
                        <div>
                            <FormGroup column>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        margin="normal"
                                        clearable
                                        label="Tgl. Reservasi Akhir"
                                        format="dd/MM/yyyy"
                                        maxDate={new Date().setDate(new Date().getDate() - 1)}
                                        minDate={validFrom === null ? new Date() : validFrom}
                                        value={validTo}
                                        onChange={(date) => {
                                            setValidTo(date)
                                            if (validFrom === null && date !== null) {
                                                setValidFrom(new Date())
                                            }
                                            if (date === null) {
                                                getData()
                                                setListDokterFilter(null)
                                            } else {
                                                updateDateRange(validFrom === null ? format(new Date(), 'yyyyMMdd') : format(new Date(validFrom), 'yyyyMMdd'), format(new Date(date), 'yyyyMMdd'))
                                            }
                                            // forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </FormGroup>
                        </div>
                    ),
                }
            }
        },
        {
            name: "booking_id",
            label: "ID Reservasi",
            options: {
                filter: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', width: 95 }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "payment_option_name",
            label: "Opsi Pembayaran",
            options: {
                filter: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', width: 135 }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "polyclinics_name",
            label: "Klinik",
            options: {
                filter: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 170, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "doctor_name",
            label: "Nama Dokter",
            options: {
                filter: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', width: 150 }}>
                            {val}
                        </div>
                    )
                }
            }
        },

        {
            name: "patient_name",
            label: "Nama Pasien",
            options: {
                filter: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 170, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "patient_phone",
            label: "No HP Pasien",
            options: {
                filter: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 120, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "queue_number",
            label: "No Antrian",
            options: {
                filter: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'center', width: 80, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },

        {
            name: "doctor_schedule_time",
            label: "Sesi Jadwal",
            options: {
                filter: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 87, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "appointment_status_name",
            label: "Status",
            options: {
                filter: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 70, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "appointment_status_reasons",
            label: "Alasan",
            options: {
                filter: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 150, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "Detail",
            label: "Detail",
            options: {
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button
                                onClick={() => handleSeeDetail(tableMeta)}
                                style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent',
                                    marginRight: 20
                                }}>
                                <img src={ic_detail} style={{ width: 30, height: 30 }} />
                            </button>
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
    ];

    const onOpen = () => {
        setVisibleCreate(true);
    };

    const opsi = [
        { name: ' Pagi, 07:00 - 11:00' },
        { name: 'Siang, 11:00 - 14:00' },
        { name: ' Sore, 14:00 - 18:00' },
    ]

    const onClose = () => {
        setVisibleCreate(false);
        setVisibleFilter(false);
        setVisibleDetail(false);
    };

    const handleSeeDetail = ({ rowData }) => {
        console.log(rowData);
        console.log(rowData[rowData.length - 2]);
        const id = rowData[13]
        console.log(id);
        const emergency = {
            "doctor_schedule_id": rowData[rowData.length - 1],
            "doctor_schedule_detail_id": rowData[rowData.length - 2],
        }
        console.log(emergency);
        api.create().getDetailReservasiDokter(id).then(response => {
            console.log(response);
            const data = response.data.data
            history.push({
                pathname: '/dokter/detail-histori-reservasi',
                name: 'Detail Histori Reservasi',
                state: {
                    data,
                    emergency,
                    jadwalPeriksa: rowData[7],
                    idDokter: rowData[rowData.length.length - 3],
                    intent: 'list'
                }
            })
        })
        // setDetail(rowData)
        // setVisibleDetail(true);
    };

    const handleClick = () => {
        setVisibleFilter(true)
        // const wrapper = wrapperRef.current;
        // // console.log(wrapper.classList);
        // wrapper.classList.toggle('is-nav-open')
        // setOpen(!open)
    }

    const doFi = (nama) => {
        console.log(nama);
        let params = `doctor_name=${nama}`
        api.create().filterReservasiDokter(nama === undefined || nama === null ? name : params).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let listDokter = response.data.data.map((item, index) => {
                        return [
                            item.doctor_schedule_date,
                            item.booking_id,
                            item.payment_option_name,
                            item.polyclinics_name,
                            item.doctor_name,
                            item.patient_name,
                            item.patient_phone,
                            item.queue_number,
                            item.doctor_schedule_time,
                            item.appointment_status_name,
                            item.appointment_id,
                            item.doctor_id,
                            item.doctor_schedule_detail_id,
                            item.doctor_schedule_id,
                        ]
                    })
                    setListDokterFilter(listDokter)
                    forceUpdate()
                }
            }
        })
    }

    const handlePoli = () => {
        console.log('masuk');
        setListPoli(true)
        handleClick()
    }

    const handleClose = () => {
        setListPoli(false)
        handleClick()
    }

    const handleCheked = (index) => {
        let temp = []
        console.log(index);
        let a = dataPoli[index].checked = !dataPoli[index].checked
        const name = dataPoli[index].name
        dataPoli.map(el => {
            if (el.checked) {
                temp.push(el.name)
            }
        })
        setValuePoli(temp)
        console.log(valuePoli);
        forceUpdate()
    }

    const resetFilter = () => {
        let params = `is_history=1`
        setParamFilter(params)
        api.create().filterReservasiDokter(params).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data == false) {
                        setListDokterFilter(response.data.data)
                    } else {
                        let temp = []
                        let listDokter = response.data.data.map((item, index) => {
                            let monthData = new Date(item.doctor_schedule_date).getMonth() + 1
                            let monthNow = new Date().getMonth() + 1
                            let dateData = new Date(item.doctor_schedule_date).getDate()
                            let dateNow = new Date().getDate()
                            if (monthData <= monthNow) {
                                // if (dateData < dateNow) {
                                let arr = [
                                    item.doctor_schedule_date,
                                    item.booking_id,
                                    item.payment_option_name,
                                    item.polyclinics_name,
                                    item.doctor_name,
                                    item.patient_name,
                                    item.patient_phone,
                                    item.queue_number,
                                    item.doctor_schedule_time,
                                    item.appointment_status_name,
                                    item.appointment_reasons,
                                    item.appointment_id,
                                    item.appointment_id,
                                    item.doctor_id,
                                    item.doctor_schedule_detail_id,
                                    item.doctor_schedule_id,
                                ]
                                temp.push(arr)
                                // }
                            }
                        })
                        setListDokterFilter(temp)
                    }
                    forceUpdate()
                }
                setVisibleFilter(false)
            }
        })
    }
    // console.log(schedule_time);

    const doFilter = () => {
        let fromDate
        let tillDate
        let polyclinic_id = []
        if (startFrom) {
            fromDate = format(startFrom, 'yyyy-MM-dd')
        }
        if (tillFrom) {
            tillDate = format(tillFrom, 'yyyy-MM-dd')
        }
        dataPoli.map(el => {
            console.log(el);
            if (el.checked) {
                polyclinic_id.push(el.id)
            }
        })
        let params;
        params = `doctor_name=${name}&polyclinic_id=${polyclinic_id != false ? `[${polyclinic_id}]` : ""}&schedule_date_from=${fromDate === undefined ? "" : fromDate}&schedule_date_to=${tillDate === undefined ? "" : tillDate}`
        console.log(params);
        setParamFilter(params)
        api.create().filterReservasiDokter(params).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data == false) {
                        setListDokterFilter(response.data.data)
                    } else {
                        let temp = []
                        let listDokter = response.data.data.map((item, index) => {
                            let monthData = new Date(item.doctor_schedule_date).getMonth() + 1
                            let monthNow = new Date().getMonth() + 1
                            let dateData = new Date(item.doctor_schedule_date).getDate()
                            let dateNow = new Date().getDate()
                            if (monthData <= monthNow) {
                                // if (dateData < dateNow) {
                                let arr = [
                                    item.doctor_schedule_date,
                                    item.booking_id,
                                    item.payment_option_name,
                                    item.polyclinics_name,
                                    item.doctor_name,
                                    item.patient_name,
                                    item.patient_phone,
                                    item.queue_number,
                                    item.doctor_schedule_time,
                                    item.appointment_status_name,
                                    item.appointment_reasons,
                                    item.appointment_id,
                                    item.appointment_id,
                                    item.doctor_id,
                                    item.doctor_schedule_detail_id,
                                    item.doctor_schedule_id,
                                ]
                                temp.push(arr)
                            }
                        })
                        setListDokterFilter(temp)
                    }
                    forceUpdate()
                }
                setVisibleFilter(false)
            }
        })
    }

    return (
        <div style={{ paddingTop: 0, overflowX: 'auto' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', }}>
                <div>

                </div>
                <div style={{ display: 'flex', flexDirection: 'initial' }}>
                    {/* <div title="Filter" onClick={() => handleClick()} style={{ height: 32, width: 40, backgroundColor: 'white', borderRadius: 20, marginRight: 25, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', marginTop: 55, zIndex: 2 }} >
                        <img
                            style={{ margin: 'auto', width: 20, marginLeft: 10, marginTop: 5 }} src={filterIcon} />
                    </div> */}
                    <div style={{ width: 50 }}>
                    </div>
                    {/* <TextField
                        // label={<Typography style={{ fontSize: '1vw', fontFamily: 'Poppins' }}>Username (NIK)</Typography>}
                        id="nama"
                        type={"text"}
                        name={"nama"}
                        placeholder={'Pencarian Dokter'}
                        // value={email}
                        onChange={(e) => {
                            setName(e.target.value)
                            doFi(e.target.value)
                            forceUpdate()
                        }}
                        variant="outlined"
                        // error={errorEmail}
                        style={{ width: 200, fontSize: '1vw', borderRadius: 30, padding: 0 }}
                        // helperText={msgEmail}
                        InputProps={{
                            style: { borderRadius: 30, backgroundColor: 'white', borderColor: 'transparent', borderStyle: 'solid', borderWidth: 0, maxHeight: 32, fontSize: '1vw', padding: 5, boxShadow: '5px 2px 10px 0 #999999' },
                            startAdornment: <InputAdornment position="end" style={{ marginRight: '10%', height: '10%' }}><img src={search} style={{ height: '2vh' }} /></InputAdornment>,
                        }}
                        InputLabelProps={{
                            style: {
                                marginLeft: '15%',
                                padding: 0
                            }
                        }}
                    /> */}

                </div>
            </div>
            <div style={{ minHeight: 600, width: props.width - (props.open === true ? 370 : 120), marginTop: 9 }}>
                <MuiThemeProvider theme={getMuiTheme()}>
                    {
                        listDokterFilter != null ?
                            <MUIDataTable
                                columns={columns}
                                data={listDokterFilter}
                                options={options}
                            />
                            :
                            <MUIDataTable
                                columns={columns}
                                data={listDokter}
                                options={options}
                            />
                    }
                </MuiThemeProvider>
            </div>

            {visibleCreate ?
                <DaftarReservasi
                    onClose={onClose}
                /> : null}
            {visibleDetail ?
                <DetailDocter
                    onClose={onClose}
                    detail={detail}
                />
                : null}

            {visibleFilter ?
                <div className="App app-popup-show">
                    <div className="popup-content background-white" style={{ height: '100%', position: 'absolute', right: 0, width: '33%' }}>
                        <div className="" style={{ height: 64, backgroundColor: '#278863', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span style={{ color: 'white', fontSize: 18, marginLeft: 40 }}>Filter</span>
                            <button
                                type="button"
                                className="btn btn-circle btn-white"
                                onClick={() => setVisibleFilter(false)}
                                style={{ marginRight: 20 }}
                            >
                                <img src={CloseImage} style={{ width: 20, height: 20 }} />
                            </button>
                        </div>
                        <div style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30 }}>
                            <div>
                                <TextField
                                    style={{ width: '100%', marginTop: 7 }}
                                    id="nama"
                                    name="nama"
                                    label="Nama Dokter"
                                    placeholder={"input Nama Dokter"}
                                    value={name}
                                    onChange={(e) => {
                                        setName(e.target.value)
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <TextField
                                    style={{ width: '100%', marginTop: 7 }}
                                    id="poliklinik"
                                    name="poliklinik"
                                    label="Pilih Poliklinik"
                                    value={valuePoli}
                                    onClick={() => handlePoli()}
                                    // onChange={() => {
                                    //     handlePoli()
                                    //     // forceUpdate()
                                    // }}
                                    inputProps={{
                                        style: {
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: 20 }}>
                                <Typography>Tanggal Reservasi</Typography>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="validFrom"
                                            label="Dari Tanggal"
                                            format="dd/MM/yyyy"
                                            maxDate={new Date().setDate(new Date().getDate() - 1)}
                                            value={startFrom}
                                            onChange={(date) => {
                                                setStartFrom(date)
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            inputProps={{
                                                startAdornment: <InputAdornment position="end" style={{ height: '10%' }}><img src={search} style={{ height: '2vh' }} /></InputAdornment>,
                                            }}
                                            style={{ width: '45%', padding: 0 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="validFrom"
                                            label="Sampai Tanggal"
                                            format="dd/MMyyyy"
                                            minDate={startFrom}
                                            maxDate={new Date().setDate(new Date().getDate() - 1)}
                                            value={tillFrom}
                                            onChange={(date) => {
                                                setTillFrom(date)
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '45%', padding: 0 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                {/* <div style={{}}>
                                    <Autocomplete
                                        options={opsi}
                                        getOptionLabel={(option) => option.name}
                                        // debug
                                        name='jadwal'
                                        id="jadwal"
                                        onChange={(event, newInputValue) => {
                                            if (newInputValue) {
                                                set_schedule_time(newInputValue.name)
                                            }
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Pilih Session"
                                            />
                                        }
                                    />
                                </div> */}
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', position: 'absolute', bottom: 14, left: '5%', width: '90%' }}>
                            <button
                                onClick={() => {
                                    setVisibleFilter(false)
                                    setName("")
                                    setValuePoli([])
                                    setStartFrom(null)
                                    setTillFrom(null)
                                    resetFilter()
                                }}
                                style={{ outline: 'none', height: 39, width: "40%", borderColor: 'transparent', backgroundColor: 'transparent', cursor: 'pointer' }}>
                                <Typography style={{ textAlign: 'center', color: '#706d6d', fontWeight: 500 }}>Reset</Typography>
                            </button>
                            <button
                                onClick={(e) => doFilter()}
                                style={{ outline: 'none', height: 39, width: "40%", borderRadius: 20, boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', backgroundColor: '#278863', borderColor: 'transparent', cursor: 'pointer' }}>
                                <Typography style={{ textAlign: 'center', color: 'white' }}>Filter</Typography>
                            </button>
                        </div>
                    </div>
                </div>
                : null}
            {
                listPoli ?
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ height: '100%', position: 'absolute', right: 0, width: '33%', overflow: 'auto' }}>
                            <div className="popup-panel grid grid-2x" style={{ height: 64, backgroundColor: '#278863' }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'white', fontSize: 18, }}>List Poliklinik</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => handleClose()
                                        }
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div>
                                {
                                    dataPoli && dataPoli.map((el, idx) => {
                                        return (
                                            <div style={{ display: 'block' }}>
                                                <div style={{ display: 'flex', marginTop: 20, borderBottom: '1px solid #ebebeb' }}>
                                                    <img src={el.media_path} style={{ width: 30, height: 30 }} />
                                                    <Typography>{el.name}</Typography>
                                                    <CustomCheckbox
                                                        checked={el.checked}
                                                        onChange={() => handleCheked(idx)}
                                                        style={{ position: 'absolute', right: 0 }}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    : null
            }
        </div>
    )
}